export default __webpack_public_path__ + "static/media/item_3@3x.eee378f3.webp";